import type { QueryClient } from '@tanstack/react-query'

/**
 * Evicts all cached entries under the given list key subtree. The next
 * component mount that needs this data fetches fresh from the network.
 * Use for list keys after create/update/delete mutations to prevent
 * stale-cache flash on destination pages.
 */
export function removeListQueries(
  qc: QueryClient,
  listKey: readonly unknown[]
): void {
  qc.removeQueries({ queryKey: listKey })
}

/**
 * Marks a detail cache entry as stale and triggers a background refetch
 * if an active observer exists. Unawaited — adds no mutation latency.
 * Secondary use only (when a mutation must also refresh a detail view
 * alongside evicting its list).
 */
export function invalidateDetailQueries(
  qc: QueryClient,
  detailKey: readonly unknown[]
): void {
  qc.invalidateQueries({ queryKey: detailKey })
}
